module.exports = __webpack_public_path__ + "static/img/sensitive_bg.5a48e99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sensitive_bg.png
// module id = 845
// module chunks = 1